import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, Box, IconButton, Menu, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import LogoutButton from "../auth/LogoutButton";
import UserInfo from "../auth/UserInfo";
import { tokens } from "../theme";

export default function Header(props) {

    const {isAuthenticated, user} = useAuth0();
    const [ anchorEl, setAnchorEl ] = useState(null);
    
    const handleClick = (event) => {
        if(anchorEl === null) {
            setAnchorEl(event.currentTarget);
        } else {
            setAnchorEl(null);
        }
    }

    const handleClose = () =>{
        setAnchorEl(null);
    }

    const parseNameInitials = (name) => {
        let parts = name.split(" ");
        return (parts.length > 1) ? `${parts[0].substring(0,1)}${parts[1].substring(0,1)}` : `${parts[0].substring(0,1)}`;
    }

    const renderAvatar = (user) => {
        let initials = parseNameInitials(user.name);
        
        // use initials if the picture is a gravatar, the URL contains "gravatar"
        return (<Avatar 
                    alt={user.name} 
                    src={!user.picture.includes("gravatar") ? user.picture : "" }
                    sx={{
                        width: "30px", 
                        height: "30px", 
                        backgroundColor: "rgb(237,28,36)",
                        color: "white",
                        fontSize: "14px",
                    }}
                >{initials}</Avatar>)
    }


    const renderUserMenu = () => {
        if(isAuthenticated) {
            return(
                <Box sx={{ flex: "0 0 auto" }}>
                    <IconButton onClick={handleClick} sx={{ padding: 0 }}>
                        {renderAvatar(user)}
                        <Menu
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <UserInfo />
                            <LogoutButton/>
                        </Menu>
                    </IconButton>
                </Box>
            )
        } else {
            return(<Box sx={{ flex: "0 0 auto" }}></Box>)
        }
    }

    // Layout mirrors the approved mockup's .header: compact ink bar, logo hard left, the product
    // name set off by a hairline rule, then a flexible spacer pushing the avatar right. The tab
    // strip renders directly beneath on the same ink field, so this stays deliberately low-profile
    // rather than the previous large centred title.
    return (
        <Stack
            direction="row"
            width="100%"
            sx={{
                backgroundColor: tokens.ink,
                alignItems: "center",
                gap: "16px",
                padding: "10px 20px",
                flex: "0 0 auto",
            }}
        >
            <Box sx={{ flex: "0 0 auto", display: "flex", alignItems: "center" }}>
                <img height="22px" src="./images/logo-reverse.png" alt="RedAlign" />
            </Box>
            <Typography
                noWrap
                sx={{
                    color: "#fff",
                    fontFamily: "Montserrat, Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: "15px",
                    letterSpacing: "0.02em",
                    opacity: 0.9,
                    borderLeft: "1px solid rgba(255,255,255,0.25)",
                    paddingLeft: "16px",
                    flex: "0 0 auto",
                }}
            >
                Data Visualizer
            </Typography>
            <Box sx={{ flex: "1 1 auto" }} />
            {renderUserMenu()}
        </Stack>
    )
}